module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"alert":{"loadError":"Požadovanou stránku nelze načíst. Zkontrolujte, zda jste online, a zkuste to znovu."}},"es":{"alert":{"loadError":"No se pudo cargar la página solicitada. Comprueba que estás en línea y vuelve a intentarlo."}},"fr":{"alert":{"loadError":"La page demandée n\u0027a pas pu être chargée. Veuillez vérifier que vous êtes en ligne et essayez encore."}}}')
  delete Component.options._Ctor
}
